import React from "react";
import { Link } from "react-router-dom";
import { AssetConfig } from "../utils/assets";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-left">
            <img
              alt="Logo"
              className="footer-logo"
              src={AssetConfig.images.logo.color1}
              tabIndex="0"
            />
            <p className="footer-logo-text">
              Dive-inpanels, an online panel company, focuses on providing
              quality survey responses to our clients representing the market
              research industry. We value the opinions you share and, in return,
              reward you in a legit yet straightforward way.
            </p>
          </div>
          <div className="footer-right">
            <div className="footer-column">
              <ul className="footer-links">
                <li>
                  <Link to="/">Home</Link>
                </li>
                <li>
                  <Link to="/why-join-us">Why Join Us</Link>
                </li>
              </ul>
            </div>
            <div className="footer-column">
              <ul className="footer-links">
                <li>
                  <Link to="/about-us">About Us</Link>
                </li>
                <li>
                  <Link to="/contact-us">Contact Us</Link>
                </li>
              </ul>
            </div>
            <div className="footer-column">
              <ul className="footer-links">
                <li>
                  <Link to="/privacy-policy">Privacy Policy</Link>
                </li>
                <li>
                  <Link to="/data-protection">Terms and Condition</Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <p className="copyright">
          © {new Date().getFullYear()} Divergent Insights. All rights reserved
        </p>
      </div>
    </footer>
  );
};

export default Footer;
